/* global window */
/* global document */
import { Fragment } from 'react'
import { withRouter } from 'react-router'
import { Layout } from 'antd'
import styles from './PrimaryLayout.module.scss';

const { Content } = Layout


const PublicMobileLayout = (props) => {
  const { children } = props;
  
  return (
    <Fragment>
      <Layout hasSider={true}>

        <div
          className={styles.container}
          id="primaryLayout"
        >
          <Content className={styles.content}>
            {children}
          </Content>
        </div>
      </Layout>
    </Fragment>
  )

}

export default withRouter(PublicMobileLayout)

